import React, { useState } from 'react';
import Popover from '@material-ui/core/Popover';
import { withStyles } from '@material-ui/styles';
import { ColorPickerStyles } from './style';
import { Button } from '@material-ui/core';
import { SwatchesPicker } from 'react-color';
import { PropTypes } from 'prop-types';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import PaletteIcon from '@material-ui/icons/Palette';
import { getDarkOrLightColor } from '../../../../../services/helpers';

const ColorPicker = ({ classes, color, changeColor, disabled, icon, removeColourOnSecondClick = false }) => {
    const [anchorEl, setAnchorEl] = useState();
    const [currentColor, setCurrentColor] = useState(color);
    return (
        <>
            <Button
                className={`${classes.colorPickerButton} ${disabled ? classes.pickerButtonDisabled : ''}`}
                style={{ background: color || '#fff', opacity: disabled ? 0.5 : 1, borderColor: 'rgba(0, 0, 0, 0.23)' }}
                disabled={disabled}
                onClick={e => {
                    if (removeColourOnSecondClick && color) {
                        changeColor({ hex: null });
                        setCurrentColor(null);
                    } else {
                        setAnchorEl(e.currentTarget);
                    }
                }}
            >
                {icon === 'BorderColorIcon' ? (
                    <BorderColorIcon style={{ color: getDarkOrLightColor(color || '#ffffff', '#ffffff', '#666') }} />
                ) : icon === 'PaletteIcon' ? (
                    <PaletteIcon style={{ color: getDarkOrLightColor(color || '#ffffff', '#ffffff', '#666') }} />
                ) : (
                    <KeyboardArrowDownIcon
                        style={{ color: getDarkOrLightColor(color || '#ffffff', '#ffffff', '#666') }}
                    />
                )}
            </Button>
            <Popover
                id="color-picker-popover"
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl()}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                <div className={classes.colorArea}>
                    <SwatchesPicker
                        color={currentColor || '#127127'}
                        onChange={color => {
                            changeColor(color);
                            setAnchorEl();
                            setCurrentColor(color.hex);
                        }}
                        onChangeComplete={() => {
                            setCurrentColor(null);
                        }}
                    />
                </div>
            </Popover>
        </>
    );
};

ColorPicker.propTypes = {
    color: PropTypes.string,
    changeColor: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    removeColourOnSecondClick: PropTypes.bool,
    icon: PropTypes.string
};

export default withStyles(ColorPickerStyles)(ColorPicker);
